import { jobClusters } from './jobClusters';
import { jobProfiles } from './jobProfiles';
import { jobPayBands } from './jobPayBands';
import { jobEmployments } from './jobEmployments';

export const jobArchitecture = {
    jobClusters,
    jobProfiles,
    jobPayBands,
    jobEmployments,
};
